module.exports = __webpack_public_path__ + "assets/media/gradient-arrow-up-right.5617161f.svg";